var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12956 17.9626C3.18511 18.5181 3.48916 19.0359 3.98139 19.4134C4.47363 19.7908 5.11811 20.0003 5.78702 20.0003H12.8796C13.5485 20.0003 14.193 19.7908 14.6853 19.4134C15.1775 19.036 15.4816 18.5181 15.5371 17.9626L16.6667 6.66699H2L3.12956 17.9626Z",
    fill: "#929292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.22222H13.3333C13.3333 1.93039 13.2644 1.64142 13.1303 1.37181C12.9963 1.1022 12.7999 0.857221 12.5523 0.650868C12.3047 0.444515 12.0107 0.280827 11.6872 0.169151C11.3636 0.0574751 11.0169 -2.55344e-06 10.6667 0H7.99999C7.6498 0 7.30304 0.0574795 6.9795 0.169157C6.65597 0.280834 6.362 0.444521 6.11438 0.650874C5.86675 0.857226 5.67033 1.1022 5.53632 1.37181C5.4023 1.64143 5.33333 1.9304 5.33333 2.22222H2.66666C1.95942 2.22222 1.28114 2.45635 0.781048 2.8731C0.280951 3.28984 0 3.85507 0 4.44444H18.6667C18.6667 4.15262 18.5977 3.86365 18.4637 3.59403C18.3297 3.32442 18.1332 3.07944 17.8856 2.87309C17.638 2.66674 17.344 2.50305 17.0205 2.39137C16.6969 2.2797 16.3502 2.22222 16 2.22222Z",
    fill: "#929292"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.37f6bc39.svg";
export { ForwardRef as ReactComponent };